
export default {
    hsk_left_time: 'เหลือเวลาในการสอบ',
    hsk_submit_paper: 'ส่งข้อสอบ',
    hsk_not_finished: 'ยังไม่เสร็จสิ้น',
    hsk_not_start: 'ยังไม่เริ่มต้น',
    hsk_finished: 'เสร็จเรียบร้อยแล้ว',
    hsk_if_test: 'การทดสอบครั้งก่อนของคุณยังไม่เสร็จสิ้น ต้องการดำเนินการสอบต่อหรือไม่',
    hsk_start_again: 'สอบใหม่',
    hsk_go_on: 'ดำเนินการสอบต่อ',
    hsk_if_save: 'ต้องการออกจากการทดสอบจำลองใช่หรือไม่ หลังจากออกแล้ว คำตอบจะถูกบันทึกไว้ สามารถดำเนินการสอบต่อในครั้งถัดไปได้',
    hsk_login_filed: '您的登录信息已失效，我们将不会保留您的答题记录',
    hsk_report: 'ผลคำตอบ',
    hsk_point: 'คะแนน',
    hsk_qualified_point: '{points}คะแนนผ่านเกณฑ์',
    hsk_part1: 'ส่วนที่ {part}',
    hsk_accuracy1: 'อัตราการตอบถูก',
    hsk_test_again: 'สอบใหม่อีกครั้ง',
    hsk_example: 'ตัวอย่าง',
    hsk_example_eg: 'เช่น',
    hsk_answer_analysis: 'การวิเคราะห์คำตอบ',
    hsk_your_answer: 'คำตอบของคุณ',
    hsk_audio_text: 'ข้อความส่วนการฟัง',
    hsk_correct_answer: 'คำตอบที่ถูกต้อง',
    hsk_listen_name: 'การฟัง',
    hskk_listen_name: 'การทดสอบลำโพงและไมโครโฟน',
    hsk_read_name: 'การอ่าน',
    hsk_write_name: 'การเขียน',
    hsk_reference_answer: 'ตัวอย่างคำตอบ',
    hsk_reference_answer_hskk: 'เนื้อหาของเสียงคำถาม',
    hsk_submit_msg: 'ต้องการส่งข้อสอบใช่หรือไม่',
    hsk_homework_no_answer: 'ยังไม่ตอบ',
    hsk_practice_sava: 'ยืนยันออกจากแบบฝึกหัดหรือไม่ ข้อมูลจะไม่ถูกบันทึกหลังจากออกจากแบบทดสอบ ',
    hsk_practice_go: 'ทำแบบฝึกหัด',
    hsk_practice_part: 'การทำแบบฝึกหัด',
    hsk_practice_operate: 'ดำเนินการ',
    hsk_practice_check: 'ตรวจดู',
    hsk_practice_num1: 'ถูก',
    hsk_practice_num2: 'ทั้งหมด {totalNum} ข้อ',
    hsk_preview_listen_msg: 'ในระหว่างที่กำลังฟังการอธิบายแบบทดสอบ คุณสามารถคลิกที่หมายเลขคำถามแต่ละข้อในส่วนการฟังได้เพื่อดูคำถามล่วงหน้า',
    hsk_preview_listen_prompt: 'ในระหว่างที่กำลังฟังการอธิบายแบบทดสอบ คุณสามารถคลิกที่หมายเลขคำถามแต่ละข้อในส่วนการฟังได้เพื่อดูคำถามล่วงหน้า ในระหว่างการสอบ ห้ามกดรีเฟรชและปิดหน้าข้อสอบ มิเช่นนั้นจะส่งผลให้ข้อมูลคำตอบของท่านสูญหายได้',
    hsk_enter_next_segment_msg: 'ต้องการไปยังขั้นต่อถัดไปใช่หรือไม่',
    hsk_enter_next_segment_preview: 'สิ้นสุดการแสดงตัวอย่างใช่หรือไม่  หลังสิ้นสุดการแสดงตัวอย่างแล้ว การทดสอบการฟังจะเริ่มขึ้น',
    hsk_enter_next_segment_listen_tip: 'คุณมี{count}ข้อที่ยังไม่ตอบในส่วนการฟัง',
    hsk_enter_next_segment_listen: 'ต้องการส่งคำตอบในส่วนการฟังใช่หรือไม่ หลังจากกดส่งแล้ว การสอบฟังจะสิ้นสุดลง',
    hsk_enter_next_segment_listen_review_start: 'ขณะนี้เป็นช่วงตรวจทานคำตอบในส่วนการฟัง  คุณมีเวลา{count}นาที ในการตรวจทานคำตอบ',
    hsk_enter_next_segment_listen_review: 'สิ้นสุดการตรวจทานคำตอบแล้วใช่หรือไม่ หลังจากสิ้นสุดการตรวจทานคำตอบในส่วนการฟัง การทดสอบการอ่านจะเริ่มขึ้น',
    hsk_enter_next_segment_read_tip: 'คุณมี{count}ข้อที่ยังไม่ตอบในส่วนการอ่าน',
    hsk_enter_next_segment_read: 'ต้องการส่งคำตอบในส่วนการอ่านใช่หรือไม่ หลังจากกดส่งแล้ว การสอบอ่านจะสิ้นสุดลง และไม่สามารถกลับไปแก้ไขได้',
    hsk_enter_next_segment_write_tip: 'คุณมี{count}ข้อที่ยังไม่ตอบในส่วนการเขียน',
    hsk_enter_next_segment_write: 'ต้องการส่งแบบทดสอบใช่หรือไม่',
    hsk_end_preview: 'สิ้นสุดการแสดงตัวอย่าง',
    hsk_submit_listen: 'ส่งแบบทดสอบการฟัง',
    hsk_end_review: 'สิ้นสุดการทบทวน',
    hsk_start_exam: 'เริ่มสอบ',
    hsk_link_test: 'คลิกเพื่อทำการทดสอบจำลอง',
    hsk_link_tips: 'ทำการทดสอบจำลองและรับเกียรติบัตร',
    hsk_buy: 'ซื้อ',
    hsk_test_ready: 'เตรียมตัวก่อนสอบ',
    hsk_test_ready_tips: 'การสอบนี้มีแบบทดสอบการฟัง โปรดปรับอุปกรณ์และตั้งค่าเสียงให้พร้อม การทดสอบการฟังกำลังจะเริ่มขึ้น',
    hsk_test_content: 'เนื้อหาการทดสอบ',
    hsk_test_num: 'จำนวนข้อ',
    hsk_total_num: 'คำถามทั้งหมด',
    hsk_test_time: 'เวลาสอบ',
    hsk_time_total: 'เวลาทั้งหมด',
    hsk_test_minute: 'นาที',
    hsk_about: 'ประมาณ',
    hsk_abbreviation: 'เขียนแบบย่อ',
    hsk_determine_ans: 'ต้องการเริ่มทำการทดสอบใช่หรือไม่',
    hsk_determine_ans_tips: 'เมื่อเริ่มตอบคำถาม คุณจะไม่สามารถดูข้อความต้นฉบับได้อีก',
    no_data: 'ไม่มีข้อมูล',
    hsk_question_number: 'จำนวนข้อ',
    hsk_test_rate: 'สัดส่วนการสอบ',
    hsk_right_rate: 'อัตราการตอบถูก',
    hsk_operation: 'ดำเนินการ',
    hsk_skip: 'ข้าม',
    hsk_spend: 'ใช้จ่าย',
    hsk_cost: 'ราคา',
    hsk_credit: 'คงเหลือ',
    hsk_pay_successfully: 'ขำระเงินสำเร็จ',
    hsk_select_amount: 'เลือกจำนวนที่ต้องการเติม',
    button_common_ok: 'ตกลง',
    button_common_cancel: 'ยกเลิก',
    change_lang_ok: 'ยืนยัน',
    change_lang_cancel: 'ยกเลิก',
    hint_player_loader_error: 'ไม่สามารถเล่นเสียงได้',
    hint_common_wait_loading: 'กำลังดาวน์โหลดเอกสาร',
    button_common_hand_in: 'ส่ง',
    test_total_question: 'ทั้งหมด{count}ข้อ',
    test_release: 'เผยแพร่',
    test_off_shelf: 'นำออก',
    test_enable: 'เริ่มต้นใช้งาน',
    test_record: 'บันทึกการทดสอบจำลอง',
    test_finish_time: 'เวลา',
    test_paper: 'แบบทดสอบ',
    test_confirm_use: 'ยืนยันการเริ่มต้นใช้งาน',
    test_confirm_off_shelf: 'ยืนยันการนำออก',
    test_has_on_shelf: 'เพิ่มเข้าไปแล้ว',
    test_un_release: 'ยังไม่เผยแพร่',
    test_un_enable: 'ยังไม่เริ่มใช้งาน',
    test_max_score: 'คะแนนสูงสุด',
    test_average_score: 'คะแนนเฉลี่ย',
    test_min_score: 'คะแนนต่ำสุด',
    test_all: 'ทั้งหมด',
    test_has_practiced: 'ทดสอบเรียบร้อยแล้ว ตรวจดูผลสอบ',
    test_paper_office: 'แบบทดสอบได้ถูกนำออกไปแล้ว',
    test_complete_introduce: 'คำแนะนำฉบับเต็ม',
    test_course_link: 'หลักสูตรทางการ',
    test_about_down_load: 'ดาวน์โหลด',
    test_pay: 'ชำระเงิน',
    mark_answer_user: 'ผู้สอบ',
    mark_answer_time: 'เวลาทดสอบ',
    mark_correct_time: 'เวลาประเมิน',
    mark_correct_status: 'สถานะการประเมิน',
    mark_correct_user: 'ผู้ประเมิน',
    mark_correct_option: 'ดำเนินการ',
    mark_correct_ing: 'กำลังประเมิน',
    mark_un_correct: 'ยังไม่ประเมิน',
    mark_has_correct: 'ประเมินแล้ว',
    mark_report_tips: 'หมายเหตุ ：ส่วนการเขียนยังไม่รวมอยู่ในผลคะแนนรวม ข้อ{markNumberDesc} จะได้รับการประเมินคะแนนจากผู้เชี่ยวชาญภายใน48ชั่วโมง เมื่อประเมินเสร็จเรียบร้อยแล้ว ผลคะแนนรวมจะมีการปรับเปลี่ยน เราจะแจ้งให้คุณทราบทางอีเมล',
    mark_report_tips_hskk: 'หมายเหตุ ：จะได้รับการประเมินคะแนนจากผู้เชี่ยวชาญภายใน48ชั่วโมง เมื่อประเมินเสร็จเรียบร้อยแล้ว ผลคะแนนรวมจะมีการปรับเปลี่ยน เราจะแจ้งให้คุณทราบทางอีเมล',
    mark_submit_btn: 'ส่ง',
    mark_submit_tips: 'ยืนยันการส่ง',
    mark_back: 'ย้อนกลับ',
    mark_correct_tips: 'กำลังประเมินแบบทดสอบ ไม่สามารถดำเนินการประเมินซ้ำได้',
    mark_correct_person: 'ประเมินโดยผู้เชี่ยวชาญ',
    search_user_message: 'ค้นหาบัญชีผู้ใช้',
    mark_current_user: 'ชื่อผู้ใช้ปัจจุบัน',
    mark_correct_paper: 'ประเมิน',
    mark_all_status: 'สถานะทั้งหมด',
    mark_all_level: 'ระดับทั้งหมด',
    mark_overtime: 'เกินเวลา',
    mark_answer: 'ตอบ',
    home_test_registration: 'ลงทะเบียนสอบ',
    home_word_outline: 'ตรวจสอบคำศัพท์',
    home_online_practice: 'ข้อสอบตัวอย่างฟรี',
    home_test: 'การสอบจำลอง',
    home_page: 'หน้าแรก',
    common_text_control_speed: 'ความเร็วในการเล่น',
    button_common_playback: 'เล่นเสียงบันทึก',
    common_text_file_error: 'ดาวน์โหลดเอกสารไม่สำเร็จ โปรดลองอีกครั้ง',
    common_text_server_error: 'ลองอีกครั้ง',
    common_text_none_network: 'อินเตอร์เน็ตไม่เสถียร',
    button_common_start_over: 'ลองอีกครั้ง',
    evaluating_tips_common: 'บันทึกเสียงการอ่านและเนื้อหามีความแตกต่างอย่างมาก โปรดบันทึกเสียงอีกครั้ง',
    evaluate_common_total_score: 'คะแนนที่ได้',
    evaluate_common_training_remain: 'คงเหลือ',
    evaluate_common_training_readyRcord: 'เตรียมบันทึกเสียง',
    evaluate_common_training_atleast: 'ระยะเวลาการบันทึกต้องมากกว่า 1 วินาที',
    evaluate_common_training_atleast2: 'ระยะเวลาการบันทึกต้องมากกว่า 2 วินาที',
    evaluate_common_training_evaluting: 'กำลังประเมินให้คะแนน',
    evaluating_tips_additionalAndBack: 'มีการอ่านซ้ำในส่วนการอ่าน ส่งผลต่อการประเมินคะแนนรวม',
    textbook_chioce_word_text_correct_tip: 'ตอบถูก เยี่ยมมาก',
    textbook_chioce_word_text_error_tip: 'ตอบผิด พยายามต่อไป',
    textbook_reading_comprehension_stem: 'การอ่าน',
    spc_back_tips: 'ต้องการออกจากหน้าแบบฝึกหัดใช่หรือไม่ หากออกแล้วคำตอบของคุณจะไม่ถูกบันทึกไว้',
    spc_level_text: 'ทดสอบวัดระดับ',
    spc_capability_assessment: 'ประเมินความสามารถ',
    spc_pick_level: 'เลือกระดับ',
    spc_listen: 'ฟัง',
    spc_speak: 'การพูด',
    spc_read: 'อ่าน',
    spc_write: 'เขียน',
    spc_translation: 'แปล',
    spc_result_tips: 'ระดับHSKของคุณอยู่ที่ระดับ{level}',
    spc_recommend_test: 'แนะนำเตรียมสอบHSKระดับ {level}',
    spc_recommend_test1: 'แนะนำเตรียมสอบ<strong> HSKระดับ {level}</strong>',
    spc_again_test: 'ทดสอบอีกครั้ง',
    spc_where_tips: 'ไม่แน่ใจในระดับภาษาจีนของตนเอง',
    spc_immediate_test: 'เริ่มการทดสอบ',
    spc_test_content: 'เนื้อหาการทดสอบ',
    spc_test_content_desc: 'ความสามารถของผู้เรียนจะพิจารณาจาก 5 ด้าน ได้แก่ การฟัง การพูด การอ่าน (การอ่านออกเสียง) การเขียน และการแปล คำถามทดสอบจะแตกต่างกันในแต่ละระดับ',
    spc_test_timer: 'เวลาทดสอบ',
    spc_test_timer_desc: 'ใช้เวลาในการทดสอบประมาณ 15 นาที ระดับยิ่งสูงจะยิ่งใช้เวลานาน',
    spc_test_result: 'ผลการทดสอบ',
    spc_test_result_desc: 'ช่วยพัฒนาทักษะและระดับของคุณได้อย่างรวดเร็ว',
    vocab_level_word: 'คำศัพท์ระดับ{level}',
    vocab_total_item: 'ทั้งหมด{total}คำ',
    vocab_search: 'ค้นหาตัวอักษรจีน/พินอิน/คำแปล',
    vocab_all_marked: 'ทั้งหมด',
    vocab_already_marked: 'บุ๊กมาร์กแล้ว',
    vocab_unmarked: 'ยังไม่บุ๊กมาร์ก',
    vocabulary: 'คำศัพท์',
    vocab_pinyin: 'พินอิน',
    vocab_translate: 'คำแปล',
    vocab_mark: 'บุ๊กมาร์ก',
    delete_confirmation: 'ต้องการลบคำศัพท์',
    cancel: 'ยกเลิก',
    del: 'ลบ',
    edit_vocab: 'แก้ไขคำศัพท์',
    save: 'บันทึก',
    add_vocab: 'เพิ่มคำศัพท์',
    hanzi: 'ตัวอักษรจีน',
    num_bihua: 'จำนวนขีดตัวอักษร',
    write_demo: 'สาธิตการเขียน',
    vocab_side: 'ส่วนประกอบของตัวอักษร',
    level: 'ระดับ',
    see_more: 'ค้นหาเพิ่มเติม',
    same_read_word: 'คำพ้องเสียง',
    samilar_read_word: 'คำที่มีเสียงคล้ายกัน',
    add_mark: 'บุ๊กมาร์ค',
    word_team: 'สร้างคำ',
    instance: 'ประโยคตัวอย่าง',
    include_num_char: 'ประกอบด้วย {total} ตัวอักษร',
    length_diff: 'ความยาวของพินอินและตัวอักษรจีนไม่ตรงกัน',
    add_word_success: 'เพิ่มคำศัพท์สำเร็จ',
    add_word_fail: 'เพิ่มคำศัพท์ไม่สำเร็จ',
    edit_word_success: 'แก้ไขคำศัพท์สำเร็จ',
    edit_word_fail: 'แก้ไขคำศัพท์ไม่สำเร็จ',
    del_success: 'ลบสำเร็จ',
    del_fail: 'ลบไม่สำเร็จ',
    mark_free: 'สามารถทำเครื่องหมายได้ตามต้องการ เช่น เช่น ทำเครื่องหมายว่า "เชี่ยวชาญแล้ว"',
    write_word_sentence: 'โปรดแต่งประโยคด้วยคำศัพท์ที่กำหนดให้',
    write_word_artical: 'โปรดแต่งเรื่องสั้นด้วยคำศัพท์ที่กำหนดให้',
    write_img_artical: 'โปรดแต่งเรื่องสั้นตามภาพที่กำหนดให้',
    write_artical_title: 'โปรดพิมพ์ชื่อเรื่อง',
    write_artical_content: 'โปรดพิมพ์เนื้อหา',
    my_wallet: 'การซื้อของฉัน',
    learn_history: 'บันทึกการเรียน',
    manage: 'การจัดการบัญชีผู้ใช้',
    birthday: 'วันเกิด',
    email: 'อีเมล',
    change_pw: 'เปลี่ยนรหัสผ่าน',
    edit_info: 'แก้ไขข้อมูล',
    lastName: 'นามสกุล',
    firstName: 'ชื่อ',
    gender: 'เพศ',
    female: 'หญิง',
    male: 'ชาย',
    non_disclosure: 'ไม่ระบุ',
    change_avatar: 'แก้ไขรูปโปรไฟล์',
    preview_avatar: 'ดูตัวอย่างรูปโปรไฟล์',
    upload_image: 'อัปโหลดรูปภาพ',
    change_image: 'เปลี่ยนรูปภาพ',
    enter_old_pw: 'กรุณาใส่รหัสผ่านเดิม',
    enter_new_pw: 'กรุณาใส่รหัสผ่านใหม่',
    enter_new_pw_again: 'กรุณาใส่รหัสผ่านใหม่อีกครั้ง',
    forget_pw: 'ลืมรหัสผ่าน',
    recharge: 'เติมเงิน',
    left_balance: 'ยอดคงเหลือที่ใช้ได้',
    consume_log: 'แบบทดสอบ',
    recharge_log: 'บันทึกกการซื้อ',
    consume_time: 'วันและเวลาซื้อ',
    consume_source: 'แหล่งข้อมูลที่ชำระ',
    consume_money: 'จำนวนเงินที่ชำระ',
    total_item_log: 'การบันทึกทั้งหมด{total}รายการ',
    recharge_time: 'เวลาเติมเงิน',
    recharge_num: 'จำนวนการเติมเงิน',
    recharge_money: 'จำนวนเงิน',
    recharge_method: 'วิธีการชำระเงิน',
    learn_content: 'เนื้อหาการเรียน',
    total_score: 'คะแนนรวม',
    view_result: 'ตรวจสอบผล',
    management: 'จัดการข้อมูล',
    give_history: 'ประวัติเครดิต',
    total_recharge: 'ยอดเติมเงินทั้งหมด',
    last_login: 'เข้าสู่ระบบครั้งล่าสุด',
    give: 'มอบเครดิต',
    gifted: 'มอบฟรี',
    give_time: 'เวลามอบเครดิต',
    give_to_person: 'ผู้รับ',
    opera_person: 'ผู้ดำเนินการ',
    give_to: 'มอบเครดิตให้',
    old_password_empty: 'ช่องกรอกรหัสผ่านเก่าไม่สามารถเว้นว่างได้',
    diff_password: 'ใส่รหัสผ่านสองครั้งไม่ตรงกัน',
    change_pw_success: 'แก้ไขรหัสผ่านสำเร็จ',
    change_pw_fail: 'แก้ไขรหัสผ่านไม่สำเร็จ',
    change_info_success: 'แก้ไขข้อมูลสำเร็จ',
    change_info_fail: 'แก้ไขข้อมูลไม่สำเร็จ',
    statistics_center: 'ศูนย์ข้อมูลสถิติ',
    select_recharge_mount: 'เลือกจำนวนที่ต้องการเติม',
    waiting_pay: 'กำลังดำเนินการชำระเงิน',
    has_no_resolve_credit: 'ยังไม่ได้รับการชำระเงิน โปรดลองซื้ออีกครั้ง',
    complete_pay: 'ชำระเงินสำเร็จแล้ว',
    pay_fail: 'ชำระเงินไม่สำเร็จ',
    give_success: 'มอบเครดิตให้สำเร็จ',
    give_fail: 'มอบเครดิตให้ไม่สำเร็จ',
    change_avatar_success: 'แก้ไขรูปโปรไฟล์สำเร็จ',
    change_avatar_fail: 'แก้ไขรูปโปรไฟล์ไม่สำเร็จ',
    enter_family_name: 'โปรกกรอกนามสกุล',
    enter_given_name: 'โปรดกรอกชื่อ',
    log_in: 'เข้าสู่ระบบ',
    log_in_error: 'เข้าสู่ระบบไม่สำเร็จ',
    email_address: 'อีเมล',
    invalid_email_address: 'อีเมลไม่ถูกต้อง',
    password: 'รหัสผ่าน',
    password_tip: 'ความยาวรหัสผ่าน 6-20 ตัวอักษร',
    invalid_password: 'รูปแบบรหัสผ่านไม่ถูกต้อง',
    have_account: 'บัญชี {text} มีผู้ใช้งานแล้ว',
    sign_up: 'ลงทะเบียน',
    sign_up_error: 'ลงทะเบียนไม่สำเร็จ',
    forget_pw_success: 'ส่งอีเมลรีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
    forget_pw_error: 'ส่งอีเมลรีเซ็ตรหัสผ่านไม่สำเร็จ',
    loading: 'กำลังดาวน์โหลด',
    account_block: 'บัญชีถูกปิดใช้งาน',
    account_block_tip: 'ต้องการข้อมูลเพิ่มเติม กรุณาติดต่อผู้ดูแลระบบของโรงเรียนคุณ',
    resend_email: 'ส่งอีเมลอีกครั้ง',
    resend_email_success: 'ส่งอีเมลอีกครั้งแล้ว',
    resend_email_error: 'ส่งอีเมลอีกครั้งไม่สำเร็จ',
    i_am: 'ฉันคือ',
    choose_role: 'คำนิยามใดสามารถอธิบายตัวคุณได้ดีที่สุด',
    choose_role_error: 'เลือกบทบาทไม่สำเร็จ',
    continue: 'ดำเนินการต่อ',
    learner: 'ผู้เรียน',
    learner_description: 'ฉันกำลังเรียนภาษาจีน',
    teacher: 'คุณครู',
    teacher_description: 'ฉันกำลังสอนภาษาจีน',
    setup_account_error: 'ตั้งค่าข้อมูลบัญชีผู้ใช้ไม่สำเร็จ',
    tos_link: 'เงื่อนไขการใช้งาน',
    privacy_link: 'นโยบายความเป็นส่วนตัว',
    email_verified: 'ยืนยันอีเมลเรียบร้อยแล้ว',
    email_verified_tip: 'ขอบคุณสำหรับการยืนยันอีเมล',
    email_verified_error: 'ยืนยันบัญชีไม่สำเร็จ',
    something_wrong: 'เกิดเหตุขัดข้อง',
    retry: 'ลองอีกครั้ง',
    guardian_consent_error: 'ดำนินการล้มเหลว',
    about_us: 'เกี่ยวกับพวกเรา',
    feedback: 'ติดต่อเรา',
    download: 'ดาวน์โหลด',
    submit: 'ส่ง',
    feedback_success: 'ส่งสำเร็จ',
    feedback_error: 'ส่งไม่สำเร็จ',
    logout: 'ออกจากระบบ',
    my_account: 'บัญชีผู้ใช้ของฉัน',
    login_signup: 'เข้าสู่ระบบ/ลงทะเบียน',
    please_enter_content: 'ฝากข้อความ (จำเป็น)',
    describe_detail: 'หากคุณต้องการร้องเรียนปัญหา โปรดระบุรายละเอียดให้มากที่สุด',
    upload_picture: 'อัปโหลดรูปภาพ (เลือกได้ มากที่สุด{maxFiles}รูป รองรับไฟล์ JPG/PNG รูปละขนาดไม่เกิน 2 MB',
    file_error: 'รูปแบบหรือขนาดของไฟล์ไม่ถูกต้อง',
    file_num_limit: 'สามารถอัปโหลดไฟล์ได้มากที่สุด{maxFiles} ไฟล์',
    sure_change_lang: 'ต้องการเปลี่ยนภาษา',
    privacy_policy_text1: 'HSK Mock.com——แพลตฟอร์มฝึกทำข้อสอบจำลอง HSK ที่ได้รับการรับรองจากสำนักงานจัดสอบวัดระดับภาษาจีนนานาชาติอย่างเป็นทางการเพียงแห่งเดียว',
    privacy_policy_text2: 'แพลตฟอร์มการทดสอบจำลองที่ได้รับการพัฒนาและดำเนินการโดยความร่วมมือระหว่างWo Hui และ Chinese Testing International  โดยมีการให้บริการการทดสอบจำลองจากคลังข้อสอบHSKและYCTฉบับจริงแก่ผู้เรียน เพื่อช่วยให้ผู้เรียนได้เข้าถึงและฝึกฝนการทำข้อสอบภาษาจีนที่ได้มาตรฐาน',
    privacy_policy_text3: 'Wo Hui Mandarin เป็นหน่วยงานในความร่วมมือของChinese Testing International',
    privacy_policy_text4: 'Chinese Testing International เป็นองค์กรมืออาชีพที่ให้บริการด้านการศึกษาและการสอบภาษาจีนระดับนานาชาติ โดยมุ่งมั่นในการให้บริการด้านการศึกษาและการสอบภาษาจีนระดับนานาชาติในด้านต่างๆอย่างมืออาชีพ อาทิ ด้านการออกแบบวิจัย การวิจัยและพัฒนาเทคโนโลยี  การดำเนินการสอบ การส่งเสริมการตลาด  เป็นต้น  เพื่อตอบสนองความต้องการของผู้เรียนภาษาจีนและสถาบันการศึกษาภาษาจีนทั่วโลก',
    privacy_policy_text5: 'Wo hui ก่อตั้งขึ้นที่สิงคโปร์ในปี 2018 โดยบริษัทการศึกษานานาชาติEiM  เป็นบริษัทที่ให้บริการด้านการสนับสนุนเทคโนโลยีและบริการแพลตฟอร์มในการเรียนภาษาจีนสำหรับผู้เรียนภาษาจีนทั่วโลก มีหลักสูตรที่หลากหลายสำหรับนักเรียน มีสื่อการสอนและเครื่องมือการสอนที่หลากหลายสำหรับครู มีสมาร์ทเทคโนโลยีที่ช่วยแบ่งเบาภาระการสอนของครูให้เป็นเรื่องง่ายและมีประสิทธิภาพยิ่งขึ้น อีกทั้งยังช่วยให้นักเรียนเรียนรู้ตามความถนัดของตนเอง และกระตุ้นให้นักเรียนสนใจในการเรียนมากยิ่งขึ้น',
    privacy_policy_text6: 'Chinese Testing International และ Wo hui  มีรากฐานความร่วมมือที่ดี  ช่วยกันส่งเสริมการพัฒนาและเผยแพร่การเรียนการสอนภาษาจีน และเพื่อให้การตัดสินระดับภาษาจีนของนักเรียนแม่นยำยิ่งขึ้น จึงได้ดำเนินการเรียนรู้แบบกำหนดเป้าหมาย และจำลองสภาพแวดล้อมให้เสมือนการสอบจริง ทั้งสองหน่วยงานจึงได้ดำเนินการความร่วมมือเชิงกลยุทธ์ในเชิงลึก เพื่อตอบสนองความต้องการในการเรียนภาษาจีนของผู้เรียนอย่างครอบคลุม',
    level_test: 'ทดสอบวัดระดับ',
    level_test_example: 'หากคุณไม่แน่ใจในระดับภาษาจีนของตนเอง สามารถทดลองสอบวัดระดับแบบด่วนได้ฟรี 1 ครั้ง เพื่อให้ทราบว่าคุณเหมาะที่จะเตรียมพร้อมในการสอบระดับใด',
    download_app_mobile: 'เพื่อประสบการณ์ที่ดียิ่งขึ้น โปรดเข้าสู่เว็บไซต์ hskmock.comโดยใช้เดสก์ท็อป หรือดาวน์โหลดAPP',
    common_video_failed: 'โหลดเสียงไม่สำเร็จ',
    member_error: 'เกิดข้อผิดพลาดกับทรัพยากร',
    agree_policy: '我已阅读并同意<u class="strong"><a href="{url}" target="_blank">《用户协议》</a></u>和<u class="strong"><a href="{url}" target="_blank">《隐私政策》</a></u>',
    please_check: 'กรุณาอ่าน "ข้อตกลงของผู้ใช้" และ "นโยบายความเป็นส่วนตัว" แล้วกดยินยอม',
    media_devices_unsupported_browserLabel: 'แนะนำให้ตั้งค่า Google Chrome เป็นเบราว์เซอร์เริ่มต้น วิธีการตั้งค่า: ยกตัวอย่าง Windows 10: การตั้งค่า-แอปพลิเคชัน-ค่าเริ่มต้นแอปพลิเคชัน-เว็บเบราว์เซอร์-เลือก Google Chrome',
    media_devices_help_title: 'เปิดไมค์แล้วใช่ไหม',
    media_devices_help_content: 'คุณต้องเปิดไมค์ก่อน จึงจะบันทึกเสียงได้',
    batch_exist_user: '{number}ผู้ใช้งานที่ลงทะเบียนแล้ว',
    batch_and: 'และ',
    batch_un_exist_user: '{number}ผู้ใช้งานที่ไม่ได้ลงทะเบียน',
    batch_from: 'มาจาก',
    batch_notes: 'หมายเหตุ',
    batch_something: 'กรุณากรอก',
    batch_people_number: 'จำนวนผู้รับ',
    batch_use_number2: 'การบริโภค',
    batch_operation_status: 'สถานะการดำเนินการ',
    batch_ing_status: 'กำลังดำเนินการ',
    batch_success: 'สำเร็จ',
    batch_failed: 'ไม่สำเร็จ',
    batch_select: 'กรุณาเลือก',
    common_to: 'ถึง',
    common_start_time: 'วันที่เริ่มต้น',
    common_end_time: 'วันที่สิ้นสุด',
    batch_search_tips: 'วางบัญชีผู้ใช้งานที่นี่ (โปรดคั่นด้วยจุลภาค คุณสามารถนำเข้าผู้ใช้งานได้สูงสุดครั้งละ 50 บัญชี)',
    common_un_exist: 'ยังไม่ได้ลงทะเบียน',
    common_invalid: 'ไม่ถูกต้อง',
    batch_all_give: 'มอบเครดิตเป็นกลุ่ม',
    batch_single_people: 'ส่วนตัว',
    batch_all: 'เป็นกลุ่ม',
    batch_name: 'ชื่อ',
    batch_added_credits: 'จำนวนเครดิต',
    batch_spent_credits: 'เครดิตที่ใช้ไป',
    batch_account_status: 'สถานะบัญชี',
    batch_Added_total: 'รวมจำนวนที่มอบให้',
    batch_spent_total: 'รวมค่าใช้จ่าย',
    batch_Remaining: 'คงเหลือ',
    batch_Recipients: 'ผู้รับ',
    batch_Active: 'เปิดใช้งานแล้ว',
    batch_search: 'ค้นหา',
    certificate_details: 'ข้อมูลรายละเอียดบนเกียรติบัตร',
    get_official_mock_certificate: 'ได้รับเกียรติบัตรรับรองอย่างเป็นทางการ',
    certificate_tips: 'รายละเอียดบนเกียรติบัตรจะนำมาจากข้อมูลส่วนบุคคลของคุณ กรุณายืนยัน:',
    country: 'สัญชาติ',
    select_country: 'กรุณาเลือกสัญชาติ',
    email_to: 'เกียรติบัตรจะถูกส่งผ่านทางอีเมลไปยัง',
    polyphonic: 'คำพ้องเสียง',
    click_tips: 'คลิกเลขข้อเพื่อตรวจคำตอบ',
    download_tips: 'ผลคะแนนผ่านเกณฑ์ ดาวน์โหลดเกียรติบัตรทันที',
    cancel_delete_account: 'ลบบัญชีผู้ใช้',
    cancel_confirm: 'ยืนัยน',
    user_apply_delete_account_title: 'ขอยกเลิกบัญชี',
    user_apply_delete_account_confirm_tip: 'ยืนยันข้อมูลการเข้าสู่ระบบ',
    user_apply_delete_account_alwaysTip: 'คุณต้องการลบบัญชีผู้ใช้และข้อมูลส่วนตัวที่เกี่ยวข้องอย่างถาวร',
    user_apply_delete_account_confirm_tip2: 'โปรดยืนยันตัวตนก่อนกดส่ง',
    user_apply_delete_account_desc: 'บัญชีของคุณ{email}ใช้สำหรับเข้าสู่ระบบและสำหรับ<a href="{wohuiLink}" target="_blank">Wo Hui Mandarin</a> และ <a href="{mockLink}" target="_blank">HSK Mock</a>',
    user_apply_delete_account_desc2: 'หลังจากลบบัญชีแล้ว จะไม่สามารถใช้บัญชีนี้เพื่อเข้าสู่ระบบแอปพลิเคชันข้างต้นได้อีกต่อไป',
    user_apply_delete_account_wohui_title: 'ยกเลิกการสมัครสมาชิกของฉัน',
    user_apply_delete_account_hsk_title: 'เครคิตคงเหลือ HSK MOCK',
    user_apply_delete_account_next_tip: 'คลิกปุ่ม "ถัดไป" ยืนยันว่าคุณได้อ่านและยอมรับข้อความข้างต้นแล้ว',
    user_apply_delete_account_next_title: 'ถัดไป',
    user_apply_delete_account_confirm_tip11: 'ยกเลิกการสมัครสมาชิกของคุณก่อนที่จะดำเนินการขอยกเลิกบัญชีของคุณ',
    cancel_delete_ok: 'ตกลง',
    cancel_delete_request_send: 'ส่งคำขอ',
    user_apply_delete_account_confirm_tip8: 'เมื่อการสมัครสมาชิกหมดอายุ บัญชีของคุณก็จะถูกลบอย่างถาวร',
    user_apply_delete_account_confirm_tip4: 'เราจะส่งอีเมลให้คุณไปยัง',
    user_apply_delete_account_confirm_tip5: 'เพื่อยืนยันว่าบัญชีของคุณถูกลบแล้ว',
    user_apply_delete_account_confirm_tip6: 'กรุณากด "ยกเลิก" เพื่อยกเลิกคำขอของคุณ',
    user_apply_delete_data_always: 'คุณต้องการยกเลิกคำขอลบบัญชีการทดสอบจำลองและข้อมูลส่วนบุคคลที่เกี่ยวข้องอย่างถาวรหรือไม่',
    cancel_delete_yes: 'ใช่',
    cancel_delete_no: 'ยกเลิก',
    user_cancel_delete_success: 'เราได้ยกเลิกคำขอของคุณแล้ว บัญชี HSK Mock ของคุณจะไม่ถูกลบ',
    user_cancel_subscribe_again: 'คุณสามารถสมัครสมาชิกใหม่ได้',
    user_apply_delete_account_confirm_tip9: 'การสมัครสมาชิกของคุณจะหมดอายุในวันที่',
    user_apply_delete_account_confirm_tip10: 'โปรดเลือกเวลาที่คุณต้องการลบบัญชี',
    user_apply_delete_account_ok_btn_title: 'เมื่อสมาชิกหมดอายุ',
    user_apply_delete_account_now_btn_title: 'ลบทันที',
    cancel_out_subscription_abnormal: 'ข้อมูลการสมัครสมาชิกไม่ถูกต้อง',
    user_apply_delete_account_confirm_tip3: 'การสมัครสมาชิกผ่าน Apple จะถูกเรียกเก็บเงินโดยอัตโนมัติ โปรดยกเลิกการสมัครสมาชิกผ่าน Apple ของคุณก่อนที่จะต่ออายุ',
    user_apply_delete_stripe_tip: 'การสมัครสมาชิกผ่าน Stripe จะถูกเรียกเก็บเงินจากบัตรเครดิตหรือเดบิตของคุณโดยอัตโนมัติ โปรดเข้าสู่เว็บไซต์ของเรา',
    user_apply_delete_account_balance: 'บัญชีของคุณมียอดคงเหลือ',
    user_apply_delete_account_balance_tip: 'เมื่อคุณลบบัญชีแล้ว ยอดคงเหลือจะไม่ถูกคืนให้',
    user_apply_delete_account_expire: 'บัญชีของคุณจะถูกลบภายในสามวัน',
    my_class_name: 'ชั้นเรียนของฉัน',
    my_class_search: 'ค้นหาชั้นเรียน',
    my_class_total: 'ทั้งหมด',
    my_class_people: 'คน',
    my_class_ci: 'ครั้ง',
    my_class_number: 'จำนวนคน',
    my_class_ci_number: 'จำนวนครั้ง',
    my_class_tips: 'ในวงกลม:สัดส่วนของHSKและYCT',
    my_class_tips1: 'นอกวงกลม:สัดส่วนของระดับHSKและYCT',
    my_class_all_class: 'ชั้นเรียนทั้งชั้น',
    follow_lesson: 'ดูบทเรียน',
    real_paper: 'ทำการทดสอบจำลอง',
    start_answer: 'เริ่มทำการทดสอบ',
    edit_message_date: 'วันที่',
    edit_message_language: 'ภาษา',
    edit_message_zh: 'ภาษาจีน',
    edit_message_en: 'ภาษาอังกฤษ',
    edit_message_title: 'ชื่อเรื่อง',
    edit_message_content: 'กรุณากรอกข้อความ',
    edit_message_show: 'แสดง',
    edit_message_save_success: 'บันทึกสำเร็จ',
    edit_message_create_success: 'เพิ่มเติมสำเร็จ',
    edit_message_edit1: 'แก้ไข',
    edit_message_follow_notice: 'ดูประกาศแจ้งเตือน',
    edit_message_textarea_tips: 'ในกรณีที่เพิ่มลิงก์ โปรดเว้นวรรคหลังลิงก์เพื่อความชัดเจน',
    edit_message_notifications: 'แก้ไขการแจ้งเตือน',
    edit_message_Send_time: 'เวลาส่ง',
    edit_message_edit_notification: 'แก้ไขการแจ้งเตือน',
    edit_message_add: 'เพิ่มเติมการแจ้งเตือน',
    edit_message_from: 'จากเวลา',
    edit_message_to: 'ถึงเวลา',
    edit_message_new_add: 'เพิ่มเติมการแจ้งเตือน',
    currency: 'สกุลเงิน',
    pay_failed: 'ดาวน์โหลดหน้าเพจไม่สำเร็จ',
    pay_un_finished: 'ชำระเงินไม่สำเร็จ',
    select_currency_tips: 'คุณสามารถเลือกสกุลเงินอื่นได้จากช่องตัวเลือกด้านล่าง',
    change_currency_tips: 'คุณสามารถเปลี่ยนสกุลเงินได้ทุกเมื่อที่ "บัญชีของฉัน"',
    my_homework: 'การบ้านของฉัน',
    my_homework_add: 'ให้การบ้าน',
    my_homework_all_classes: 'ชั้นเรียนทั้งชั้น',
    my_homework_paper: 'ชื่อแบบทดสอบ',
    my_homework_sent_to: 'ส่ง',
    my_homework_sent_on: 'เวลาส่ง',
    my_homework_due_on: 'หมดเวลา',
    my_homework_submitted_assignees: 'จำนวนผู้ส่ง',
    my_homework_class_hint: 'ไอคอนบริเวณรอบๆชื่อชั้นเรียนบ่งบอกว่ามอบหมายงานให้นักเรียนบางส่วนในชั้นเรียน',
    my_homework_delay_hint: 'แสดงการอนุญาตให้ผู้เรียนสามารถส่งงานหลังจากวันและเวลาที่ครบกำหนด',
    my_homework_add_send_assignment: 'ส่งการบ้าน',
    my_homework_add_new_assignment: 'การบ้านใหม่',
    my_homework_edit_assignment: 'แก้ไขงาน',
    my_homework_add_assignment: 'เพิ่มงาน',
    my_homework_add_assignment_details: '1. รายละเอียดของการบ้าน',
    my_homework_add_issue_time: 'เวลาส่ง',
    my_homework_add_whether_submit: 'อนุญาตให้ส่งได้หลังเวลาที่กำหนด',
    my_homework_add_note: 'หมายเหตุ',
    my_homework_add_assignees: '2. ผู้รับ',
    my_homework_edit_add_assignees: 'ผู้รับ',
    my_homework_add_group: 'เลือกชั้นเรียน',
    my_homework_add_immediate_release: 'ส่งทันที',
    my_homework_add_time_release: 'ตั้งเวลาส่ง',
    my_homework_add_are: 'ใช่',
    my_homework_add_no: 'ไม่',
    my_homework_detail_back: 'กลับไปสู่การบ้านของฉัน',
    my_homework_detail_sent_to: 'ส่งให้',
    my_homework_detail_leamers_in: 'นักเรียนอยู่ใน',
    my_homework_detail_on: 'ที่',
    my_homework_detail_to_complete_by: 'ส่งสำเร็จที่',
    my_homework_detail_add_assignee: 'เพิ่มผู้รับ',
    my_homework_detail_assignee: 'ผู้รับ',
    my_homework_search_placeholder: 'กรุณาใส่เนื้อหาที่ต้องการค้นหา',
    my_homework_stu_sent_by: 'ผู้ส่ง',
    my_homework_total_topic_count: 'ทั้งหมด{count}ข้อ',
    my_homework_time_full: '{min} นาที',
    my_homework_select_date_time: 'เลือกวันและเวลา',
    my_homework_delete_assignment_title: 'ลบการบ้าน',
    my_homework_delete_assignment_tips: 'ต้องการลบการบ้านใช่หรือไม่ หากดำเนินการลบแล้วจะไม่สามารถยกเลิกได้',
    my_homework_assignment_add_fail: 'ส่งไม่สำเร็จ',
    my_homework_assignment_add_success: 'ส่งสำเร็จ',
    my_homework_assignment_edit_success: 'แก้ไขสำเร็จ',
    my_homework_assignment_edit_fail: 'แก้ไขไม่สำเร็จ',
    my_homework_assignment_delete_fail: 'ลบไม่สำเร็จ',
    my_homework_assignment_delete_success: 'ลบสำเร็จ',
    my_homework_assignment_due_on: 'เวลาที่กำหนด',
    my_homework_assignment_product: 'ชื่อผลิตภัณฑ์',
    my_homework_assignment_certificate: 'เกีรยติบัตร',
    my_homework_assignment_reset: 'รีเซ็ต',
    my_homework_assignment_reset_title: 'รีเซ็ตส่วนที่เลือกทั้งหมดหรือไม่',
    my_homework_assignment_gifted: 'จำนวนของขวัญ',
    my_homework_assignment_papers: 'แบบทดสอบ',
    my_homework_assignment_send_to: 'ส่งการบ้านไปยัง',
    my_homework_assignment_close_tip: 'ขณะนี้การบ้านที่ส่งยังไม่ได้ถูกบันทึก ต้องการออกหรือไม่',
    pay_callback_tips: 'หากคุณไม่ใช่พลเมืองจีนแต่อาศัยอยู่ที่ประเทศจีน เราแนะนำให้ใช้บัตรvisa หรือ mastercard เรากำลังดำเนินการแก้ปัญหาที่จะให้คุณใช้ WeChat, Alipay และ UnionPay ชำระเงินได้อย่างสะดวก',
    no_available_class: 'ไม่มีชั้นเรียนให้เลือก',
    payment_method: 'วีธีการชำระเงิน',
    wechat_pay: 'ชำระเงินด้วยWechat',
    alipay_payment: 'ชำระเงินด้วยAlipay',
    card_payment: 'ชำระเงินด้วยบัตรเครดิต',
    card_payment_description: 'เฉพาะบัตรธนาคารต่างประเทศเท่านั้น',
    payment_to_wohui: 'ชำระเงินไปยังบริษัทWohui Technology (Shanghai)',
    order_submitted: 'ส่งคำสั่งซื้อเรียบร้อย กรุณาชำระเงินโดยเร็วที่สุด',
    order_number: 'หมายเลขคำสั่งซื้อ',
    code_expires: 'QR Code ยังเหลือเวลาอีก <span style=""color: #fc5a5a;font-size: 16px;font-weight: 500;"">{time}</span>',
    use_weChat: 'โปรดใช้Wechatสแกนเพื่อชำระเงิน',
    code_expired: 'QR Code หมดอายุแล้ว',
    amount_payable: 'จำนวนเงินที่ต้องชำระ :',
    use_code: 'ใช้รหัส',
    tests: 'บันทึกการสอบ',
    level_title: 'คุณตั้งเป้าหมายไว้ที่ระดับใด',
    level_des: 'หากคุณยังไม่มั่นใจ สามารถทดลองสอบได้ 1 ครั้ง D24<b style="color: #000;cursor: pointer;font-weight: 700;" class="clickable">ทดสอบวัดระดับฟรี ></b>',
    level_HSK_text1: '<b>HSK</b>เป็นชื่อย่อของ “Hanyu Shuiping Kaoshi”มีความหมายว่า การสอบวัดระดับความรู้ทางภาษาจีน',
    level_HSK_text2: 'การสอบนี้เป็นการสอบวัดระดับภาษาจีนที่ได้รับความนิยมมากที่สุดในโลก',
    level_YCT_text1: '<b>YCT</b> เป็นชื่อย่อของ “Youth Chinese Tests”',
    level_YCT_text2: 'มีความหมายว่า การสอบวัดระดับความรู้ทางภาษาจีนสำหรับเยาวชน',
    level_BEGINNER: 'ระดับต้น',
    level_INTERMEDIATE: 'ระดับกลาง',
    level_ADVANCED: 'ระดับสูง',
    level_dialog_title: 'ระดับการทดสอบ',
    level_dialog_content: 'การทดสอบระดับตนเองแบบฟรีใช้เวลาประมาณ 15 นาที และผลการทดสอบจะแสดงให้เห็นว่าปัจจุบันคุณอยู่ที่HSKระดับใด และกำลังพัฒนาไปสู่HSKระดับใด ในแต่ละทักษะทั้งการฟัง การอ่าน การเขียน และการพูด',
    level_dialog_login: 'เข้าสู่ระบบ/ลงทะเบียน',
    level_dialog_start: 'เริ่มทดสอบวัดระดับ',
    about_us_first_paragraph: '<b>HSK Mock</b>เป็นแพลตฟอร์มจำลองการสอบวัดระดับความรู้ทางภาษาจีน HSK และ YCT อย่างเป็นทางการเพียงแห่งเดียว แพลตฟอร์มนี้จัดทำขึ้นโดยความร่วมมือระหว่าง<b>Chinese Testing International </b>และ<b>Wo Hui Mandarin</b>',
    about_us_second_paragraph: '<b>Chinese Testing International</b> (CTI) เป็นคณะกรรมการจัดสอบ HSK และ YCT เป็นบริษัทจำกัดที่มีสำนักงานใหญ่ตั้งอยู่ที่กรุงปักกิ่ง ซึ่งส่งเสริมและสนับสนุนการเรียน การสอน และการทดสอบภาษาจีนในฐานะภาษาต่างประเทศทั่วโลก โดยการให้บริการที่หลากหลายแก่บุคคลและสถาบันต่างๆ',
    about_us_third_paragraph: '<b>Wo Hui Mandarin</b> (Wo Hui) เป็นบริษัทจำกัดมีสำนักงานใหญ่ตั้งอยู่ที่ประเทศสิงคโปร์ จัดทำแพลตฟอร์มออนไลน์อย่างเป็นทางการที่จัดเตรียมหลักสูตรและการสอบ HSK และ YCT โดยใช้เทคโนโลยีเป็นสื่อสร้างสรรค์การเรียนรู้ภาษาจีนให้เป็นเรื่องง่ายสำหรับนักเรียน และช่วยให้ครูสามารถชี้แนะแนวทางการเรียนรู้ให้แก่นักเรียนตามแนวทางของแต่ละคนได้',
    about_us_cti_text: 'เรียนรู้เพิ่มเติม',
    about_us_wohui_text: 'หากต้องการเรียนรู้เพิ่มเติม กรุณาติดต่อ',
    listening_section: 'ส่วนการฟัง',
    reading_section: 'ส่วนการอ่าน',
    writing_section: 'ส่วนการเขียน',
    review_answers: 'ตรวจสอบคำตอบ',
    characters_long: '如果您还未注册账户，请设置一个6到20个字符的密码。',
    complete_profile: 'กรอกข้อมูลส่วนตัวให้สมบูรณ์',
    verify_email: 'ยืนยันอีเมลของคุณ',
    link_sent: 'ขอบคุณสำหรับการลงทะเบียน กรุณาคลิกลิงก์ที่ส่งให้เพื่อยืนยันว่าเป็นอีเมลที่ถูกต้อง',
    resend_link: 'ส่งลิงก์อีกครั้ง',
    restart: 'เปิดเครื่องใหม่',
    parental_consent: 'ความยินยอมจากผู้ปกครอง',
    sent_parental: 'ขอบคุณสำหรับการลงทะเบียน โปรดขอความยินยอมจากพ่อแม่หรือผู้ปกครองของคุณโดยทำตามคำแนะนำที่เราส่งไปในอีเมล',
    thank_you: 'ขอบคุณ',
    or_return: 'หรือกลับสู่โปรแกรม',
    child_profile: 'ข้อมูลส่วนตัวของบุตรหลาน',
    sign_up_privacy: 'เข้าพเจ้าได้อ่านเงื่อนไขและยอมรับ<a class="link" target="_blank" rel="noopener noreferrer" href="{url}">เงื่อนไขการบริการ</a>และ<a class="link" target="_blank" rel="noopener noreferrer" href="{userUrl}">นโยบายความเป็นส่วนตัว</a>',
    give_consent: 'ข้าพเจ้ายินยอม',
    delete_child_details: 'ลบข้อมูลของบุตรหลาน',
    account_created: 'สร้างบัญชีใหม่',
    emailed_know: 'ได้ส่งอีเมลไปยัง<span style="font-weight: 700">{email}</span>โปรดให้ความยินยอม',
    account_deleted: 'ลบบัญชีผู้ใช้',
    child_know_deleted: 'โปรดแจ้งให้บุตรหลานของคุณทราบว่าข้อมูลของพวกเขาได้ถูกลบออกไปแล้ว',
    request_email: 'ข้อมูลข้างต้น (ยกเว้นที่อยู่อีเมล) สามารถแก้ไขได้หลังจากเข้าสู่ระบบ โปรดอนุญาตให้บุตรหลานของคุณสร้างบัญชีหรือขอให้เราลบข้อมูลของพวกเขา',
    preferred_currency: 'สกุลเงิน',
    parent_guardian: 'ผู้ปกครอง',
    class_name: 'ชื่อชั้นเรียน',
    tofficial_platform: 'แพลตฟอร์มฝึกทำข้อสอบจำลอง hsk อย่างเป็นทางการเพียงแห่งเดียว',
    proficiency_tests: 'เตรียมความพร้อมสำหรับการสอบวัดระดับความรู้ภาษาจีนที่ได้รับความนิยมมากที่สุดในโลก',
    get_started: 'เริ่ม',
    platform_china: 'แพลตฟอร์มนี้ยังให้บริการสำหรับผู้สมัครภายในประเทศจีนด้วย',
    take_confidence: 'ให้คุณเข้าร่วมการสอบHSKด้วยความมั่นใจ',
    practice_tests: 'ฝึกฝนการทดสอบHSKและYCT',
    using_time: 'ใช้ข้อสอบจริงจากการสอบรอบที่ผ่านๆมา ซึ่งได้รับการอนุญาตให้ใช้อย่างเป็นทางการจาก CTI การฝึกฝนทำแบบทดสอบจำลองจะช่วยให้ท่านคุ้นเคยกับรูปแบบคำถามประเภทต่างๆ รู้ข้อกำหนด และสามารถทำข้อสอบเสร็จได้ภายในเวลาที่กำหนด',
    instant_results: 'รู้ผลทันที',
    each_test_question: 'ทบทวนข้อสอบที่ทำเสร็จแล้วในแต่ละข้อ คุณสามารถดูคะแนนพร้อมคำเฉลยได้ เพื่อช่วยให้คุณรู้ข้อผิดพลาดของตนเอง พร้อมแก้ไขข้อผิดพลาด และก้าวไปสู่ความสำเร็จ',
    track_progress: 'บันทึกความคืบหน้า',
    ready_next_test: 'แพลตฟอร์มจะบันทึกวันที่และเวลาของการสอบจำลองแต่ละครั้งโดยอัตโนมัติ รวมถึงการบันทึกการพัฒนาทักษะและการเปลี่ยนแปลงของคะแนนแต่ละครั้ง บันทึกเหล่านี้จะช่วยให้คุณทราบว่าคุณพร้อมจะเข้าร่วมการสอบจริงเมื่อใด เพื่อให้ได้ผลคะแนนที่ดีที่สุด',
    receive_official_certificates: 'ได้รับเกียรติบัตรรับรองอย่างเป็นทางการ',
    certificates_provide_evidence: 'คุณจะได้รับเกียรติบัตรรับรองผลทุกครั้งที่ทดสอบจำลองผ่าน เกียรติบัตรเหล่านี้เป็นเครื่องยืนยันได้ว่าคุณมีความรู้ด้านภาษาจีนในระดับหนึ่ง',
    ready_next_level: 'เตรียมพร้อมสำหรับระดับที่สูงขึ้น',
    check_description: 'ตรวจสอบคำอธิบายของระดับ HSK ถัดไปของคุณเพื่อให้ทราบว่าเป้าหมายของคุณคืออะไร ทำความคุ้นเคยกับข้อกำหนดและรูปแบบของการสอบ ทบทวนคำศัพท์และดูตัวอย่างข้อสอบ เพื่อให้คุณรู้เทคนิคในการสอบอย่างรอบด้าน',
    on_the_move: 'ใช้งานผ่านมือถือหรือแท็บเล็ตใช่หรือไม่',
    download_mobile: 'ดาวน์โหลดAPPเพื่อใช้งานบนมือถือ',
    hsk_beginner_advanced: '<span style="font-weight: 700">HSK</span> เป็นชื่อย่อของ “Hanyu Shuiping Kaoshi”มีความหมายว่า การสอบวัดระดับความรู้ทางภาษาจีน เป็นการสอบภาษาจีนที่ได้รับความนิยมมากที่สุดในโลก โดยมีทั้งหมด 9 ระดับ ตั้งแต่ระดับพื้นฐานไปจนถึงระดับสูง',
    more: 'เพิ่มเติม',
    ytc_beginner_advanced: '<span style="font-weight: 700">YCT</span> เป็นชื่อย่อของ “Youth Chinese Tests”มีความหมายว่า การสอบวัดระดับความรู้ทางภาษาจีนสำหรับเยาวชน โดยมีทั้งหมด 4 ระดับ ตั้งแต่ระดับพื้นฐานไปจนถึงระดับกลาง',
    coming_end: 'พบกับการทดสอบจำลองการพูดในปลายปี2023',
    candidates_proficiency_speaking: 'การสอบนี้เป็นการทดสอบความสามารถในการพูดภาษาจีนของผู้สอบ',
    level_oral_tests: '<span style="font-weight: 700">HSKK</span> เป็นชื่อย่อของ“Hanyu Shuiping Kouyu Kaoshi”มีความหมายว่า การสอบวัดระดับความรู้ด้านการพูดภาษาจีน',
    check_test_dates: 'ค้นหาวันและเวลาสอบ',
    book_test: 'สมัครสอบ',
    international_platform: 'แพลตฟอร์มของจีนตั้งอยู่ที่ประเทศจีน แพลตฟอร์มสากลตั้งอยู่ที่ประเทศสิงคโปร์ ทั้งสองแพลตฟอร์มเป็นอิสระจากกัน โปรดเลือกแพลตฟอร์มที่เหมาะกับคุณ',
    mock_platform: '官方模拟考试平台',
    home_proficiency_tests: '为最受欢迎的中文水平测试做准备',
    currency_type: 'เลือกสกุลเงิน',
    Pick_your_level: 'เลือกระดับที่ต้องการ',
    About_this_level: 'แนะนำระดับ',
    test_session: 'ครั้งที่ทดสอบ',
    Learning_resources: 'สื่อการเรียนรู้',
    Take_practice_test: 'การสอบจำลอง',
    Compare_syllabuses: 'เปรียบเทียบหลักสูตร',
    table_shows_syllabuses: 'ตารางแสดงระดับ HSK ในหลักสูตรต่างๆ',
    forrgin_lang: '0547 คือ ภาษาจีนในฐานะภาษาต่างประเทศ',
    Second_Language: '0523 คือ ภาษาจีนในฐานะภาษาที่สอง',
    Requirement_entry: 'เงื่อนไขการลงทะเบียนเข้าใช้งาน',
    most_Chinese_universities: 'มหาวิทยาลัยในจีนส่วนใหญ่',
    Qing_Hua: 'มหาวิทยาลัยชิงหัว',
    beijing_university: 'มหาวิทยาลัยปักกิ่ง',
    working_towards: 'หลังจากการทดสอบ ขอแนะนำให้คุณเตรียมตัวสอบ',
    On: 'ที่',
    Level_test: 'ทดสอบวัดระดับ',
    Retake_level_test: 'ทดสอบอีกครั้ง',
    practice_test: 'เข้าร่วมฝึกทดสอบ 1 ครั้ง',
    Compare_syllabuses_a: 'เปรียบเทียบหลักสูตรต่าง ๆ กับหลักสูตร HSK',
    Not_sure: 'ไม่แน่ใจในระดับของตนเอง',
    free_level_test: 'เข้าร่วมการทดลองสอบฟรี',
    Examples: 'ตัวอย่าง',
    product_code: 'รหัสแลกแบบทดสอบ',
    enter_paper: 'กรอกรหัสเพื่อทำการทดสอบ',
    no_code: 'ยังไม่มีรหัสใช่หรือไม่? สามารถซื้อได้ที่หน่วยงานพันธมิตรของเรา',
    to_partner: 'ไปยังหน้าเว็บไซต์หน่วยงานพันธมิตร',
    code_here: 'กรอกรหัสที่นี่',
    start_assigment: 'เริ่ม',
    view_assigment: 'ตรวจดูผลสอบ',
    continue_assigment: 'ดำเนินการต่อ',
    choose_method: 'เลือกวิธีการชำระเงิน',
    choose_new_method: 'โปรดเลือกวิธีการปลดล็อคการทดสอบใหม่',
    browser_layer: 'กรุณาใช้เบราว์เซอร์ Google Chrome บนเครื่องคอมพิวเตอร์หรือใช้APPบนอุปกรณ์มือถือและแท็บเล็ต',
    partner_title1: 'หวังว่าคุณจะมาเป็น',
    partner_title2: 'พันธมิตรในพื้นที่',
    company_name: 'ชื่อบริษัท',
    company_website: 'เว็บไซต์บริษัท',
    teachers_count: 'จำนวนครู HSK ในความร่วมมือของคุณ',
    learners_count: 'จำนวนผู้เรียน HSK ในความร่วมมือของคุณ',
    add_msg: 'ฝากข้อความเพิ่มเติม',
    contact_style: 'ช่องทางการติดต่อ',
    send: 'ส่ง',
    partner_forms_desc: 'ในฐานะพันธมิตรของเรา คุณจะเป็นผู้ติดต่อหลักให้แก่ผู้สอบ คุณครู และโรงเรียนในเขตพื้นที่ประเทศของคุณ<br><br>พันธมิตรของเราโดยปกติแล้วเป็นศูนย์อบรมและทดสอบHSK ที่ต้องการขยายเครือข่ายการจัดสอบ <br><br>หากคุณต้องการเป็นพันธมิตรของเรา กรุณาใช้บัญชีทดสอบ HSK Mock ส่วนบุคคลก่อน<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">เข้าสู่ระบบ</span>กรอกข้อมูลด้านล่าง เราจะติดต่อกลับโดยเร็วที่สุด',
    submit_success: 'ส่งสำเร็จแล้ว',
    help_students_for_testing: 'คุณกำลังช่วยเตรียมความพร้อมในการสอบให้นักเรียนใช่หรือไม่',
    help_students_for_testing_desc: 'ครูมีบทบาทสำคัญที่จะช่วยให้นักเรียนบรรลุเป้าหมายในการสอบครั้งต่อไป <br>จะช่วยให้ครูส่งเสริมการเรียนรู้ของนักเรียนตามแนวทางของแต่ละคนได้',
    become_partner: 'มาร่วมเป็นพันธมิตรกับเรา',
    become_partner_desc: 'ผู้สอบสามารถใช้ภาษาแม่ของตนติดต่อสอบถามรายละเอียดในการทดสอบกับศูนย์สอบในพื้นที่ประเทศของตนได้ และยังสามารถชำระเงินผ่านช่องทางที่คุ้นเคยได้',
    partnership: 'สำรวจความร่วมมือ',
    students_forward: 'เพิ่มศักยภาพให้นักเรียนของคุณ',
    hsk_confidence: 'เข้าร่วมการสอบHSKด้วยความมั่นใจ',
    try_it_out: 'เริ่มทดลอง',
    walk_through: 'ทำความคุ้นเคยกับขั้นตอนการสอบ',
    teachers_page_desc1: 'ฟังก์ชั่นในแพลตฟอร์มไม่เพียงแต่สนับสนุนการสอนในชั้นเรียนเท่านั้น แต่ยังเหมาะสำหรับการสอนแบบตัวต่อตัวอีกด้วย ให้นักเรียนคุ้นเคยกับคำถามประเภทต่างๆ ทบทวนคำศัพท์ที่จำเป็น ดูตัวอย่างเนื้อหาข้อสอบ และเข้าใจถึงเทคนิคในการทำข้อสอบ',
    assign_practice_papers: 'กำหนดวันและเวลาส่งข้อสอบของนักเรียน',
    teachers_page_desc2: 'สามารถส่งข้อสอบให้นักเรียน คุณสามารถใช้แบบทดสอบจำลองในการจัดสอบจริงได้ เพื่อช่วยให้นักเรียนคุ้นเคยกับคำถามประเภทต่างๆ ในการสอบHSK และสามารถทำข้อสอบแต่ละส่วนให้เสร็จภายในเวลาที่กำหนดได้',
    get_instant_results: 'รู้ผลทันที',
    teachers_page_desc3: 'ครูไม่ต้องตรวจข้อสอบด้วยตนเอง และสามารถตรวจดูได้ว่านักเรียนได้ทำข้อสอบที่กำหนดครบถ้วนหรือไม่ และตรวจดูคะแนนข้อสอบของนักเรียนทุกคนได้',
    review_their_answers: 'ย้อนดูคำตอบของนักเรียน',
    teachers_page_desc4: 'สามารถเจาะลึกผลการทดสอบของนักเรียนได้ และจะทำให้ทราบถึงปัญหาของนักเรียน การทบทวนคำตอบของนักเรียนจะทำให้คุณสามารถพัฒนาแผนการสอนและให้คำชี้แนะแก่นักเรียนได้อย่างถูกต้อง',
    track_prog: 'ติดตามความคืบหน้าของนักเรียน',
    teachers_page_desc5: 'บันทึกคะแนนและคำตอบของนักเรียนในการสอบแต่ละครั้งอย่างละเอียด อีกทั้งยังบันทึกการพัฒนาทักษะและการเปลี่ยนแปลงของคะแนนในแต่ละครั้ง บันทึกเหล่านี้จะช่วยให้คุณครูทราบว่านักเรียนพร้อมจะเข้าร่วมการสอบจริงเมื่อใด เพื่อให้ได้ผลคะแนนที่ดีที่สุด',
    students_next_level: 'พัฒนาศักยภาพนักเรียนไปอีกขั้น',
    teachers_page_desc6: 'แพลตฟอร์มในเครือของเรามีคู่มือและสื่อการเรียนการสอน HSK และ YCT ที่เป็นทางการ ให้คุณใช้ได้ตามความต้องการ ช่วยให้ครูสามารถส่งเสริมการเรียนรู้ของนักเรียนตามแนวทางของแต่ละคนได้',
    teaching_resources: 'สื่อการสอน',
    for_teachers: 'คุณครู',
    teachers_desc1: 'กรุณาใช้บัญชีส่วนบุคคล<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">เข้าสู่ระบบ</span> แพลตฟอร์มการทดสอบจำลอง HSK Mock',
    teachers_desc2: 'กรุณากรอกข้อมูลด้านล่าง เราจะตั้งค่าการทดลองใช้งานฟรีให้โรงเรียนของคุณ',
    school_name: 'ชื่อโรงเรียน',
    school_web: 'เว็บไซต์โรงเรียน',
    num_of_hsk_teachers: 'จำนวนครูผู้สอนHSK',
    num_of_hsk_learners: 'จำนวนผู้เรียนHSK',
    hsk_submit_reading: 'การอ่าน',
    pay_tip: 'หากคุณต้องการใช้ Alipay หรือ Wechat เพื่อชำระค่าแบบทดสอบจำลอง โปรดใช้เว็บไซต์จีน hskmock.cn',
    use_pc_or_app: 'เริ่มเตรียมพร้อม โปรดใช้คอมพิวเตอร์ล็อคอินเข้าสู่ระบบ หรือดาวน์โหลดAPP',
    download_certificate: 'ดาวน์โหลดเกียรติบัตร',
    create_certificate: 'สร้างเกียรติบัตร',
    certificate_is_downloaded: 'ดาวน์โหลดเกียรติบัตรแล้ว',
    pay_discount_title: 'คุณต้องการซื้อแบบทดสอบ{level}จำนวนเท่าใด',
    total: 'รวมทั้งสิ้น',
    pay: 'ชำระ',
    price_desc: 'หากคุณซื้อแบบทดสอบหลายชุดในครั้งเดียวกัน จะได้รับส่วนลดพิเศษตามที่กำหนดไว้',
    the_level: 'ระดับ',
    discounted_price: 'ราคา',
    price_contact_us: 'นอกจากนี้ เรายังให้บริการจัดซื้อจำนวนมากสำหรับโรงเรียนและหน่วยงานต่างๆอีกด้วย กรุณา<span style="color: #faae56; text-decoration-line: underline; cursor: pointer">ติดต่อเรา</span>เพื่อปรึกษาและแจ้งความประสงค์',
    get_a_discount: 'รับส่วนลด',
    finished_pay_discount_title: 'นี่คือรหัสแลกรับแบบทดสอบ{level_name}ของคุณ',
    btn_goto_papers: 'ค้นหาแบบทดสอบ{level_name}',
    test_count: '{test_num}ครั้งการทดสอบ',
    unit_price: '{price}/การสอบ1ครั้ง',
    buy_code_tip: 'เราได้ส่งรหัสแลกรับแบบทดสอบเหล่านี้ผ่านทางอีเมลให้คุณแล้ว ขณะนี้เพียงเลือกแบบทดสอบ {level_name} ที่คุณต้องการ ป้อนรหัสแลกรับแบบทดสอบเพื่อปลดล็อค',
    discount_codes_left_tip: 'หลังจากทำการทดสอบเสร็จ，แบบทดสอบระดับนี้ของคุณ<span style="color: #62C1A5;font-size: 16px;font-weight: 500;">เหลือ{count}รหัส</span>',
    manage_class: 'จัดการชั้นเรียน',
    to_manage_class: 'ระบบการจัดการชั้นเรียนจะเปิดขึ้นในหน้าใหม่ เมื่อคุณดำเนินการเสร็จแล้ว โปรดกลับมาที่หน้านี้และกดรีเฟรช',
    code_used: 'ใช้แล้ว',
    code_can_be_used: 'ไม่ได้ใช้',
    no_test: 'จำนวน',
    history_purchase_quantity: 'จำนวน',
    hsk_listen_part_title: 'การฟังส่วนที่{count}',
    hsk_read_part_title: 'การอ่านส่วนที่{count}',
    hsk_write_part_title: 'การเขียนส่วนที่{count}',
    Description: 'แนะนำ',
    Test_format: 'รูปแบบการสอบ',
    Vocabulary: 'คำศัพท์',
    sso_login_signup: 'เข้าสู่ระบบ/ลงทะเบียน',
    sso_email_address: 'อีเมล',
    sso_password: 'รหัสผ่าน',
    sso_characters_long: 'หากคุณยังไม่ได้ลงทะเบียนบัญชีผู้ใช้ กรุณาตั้งรหัสผ่าน 6 ถึง 20ตัวอักษร',
    sso_forget_pw: 'ลืมรหัสผ่าน',
    sso_agree_policy: 'ข้าพเจ้าได้อ่านเงื่อนไขและยอมรับ<u class="strong"><a href="{url}" target="_blank">เงื่อนไขการให้บริการ</a></u>และ<u class="strong"><a href="{userUrl}" target="_blank">นโยบายความเป็นส่วนตัว</a></u>',
    sso_continue: 'ดำเนินการต่อ',
    sso_please_check: 'โปรดอ่าน "เงื่อนไขการให้บริการ" และ "นโยบายความเป็นส่วนตัว" และกดยอมรับ',
    sso_invalid_email_address: 'ที่อยู่อีเมลไม่ถูกต้อง',
    sso_invalid_password: 'รหัสผ่านไม่ถูกต้อง',
    sso_loading: 'กำลังดาวน์โหลด',
    sso_mock_platform: 'แพลตฟอร์มจำลองการสอบอย่างเป็นทางการ',
    sso_home_proficiency_tests: 'เตรียมความพร้อมสำหรับการสอบวัดระดับความรู้ทางภาษาจีนที่ได้รับความนิยมมากที่สุด',
    sso_guardian_consent_error: 'ดำเนินการล้มเหลว',
    sso_forget_pw_success: 'ส่งอีเมลรีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
    sso_forget_pw_error: 'ส่งอีเมลรีเซ็ตรหัสผ่านล้มเหลว',
    sso_log_in_error: 'เข้าสู่ระบบไม่สำเร็จ',
    sso_download_app_mobile: 'เพื่อประสบการณ์ที่ดียิ่งขึ้น โปรดเข้าสู่เว็บไซต์ hskmock.comโดยใช้เดสก์ท็อป หรือดาวน์โหลดAPP',
    sso_no_binding_info_tip: 'การรับข้อมูลของคุณไม่สำเร็จ',
    sso_third_login_tip: 'กรุณาเลือกเว็บไซต์ที่ต้องการ',
    sso_third_login_wohui: 'ไปยัง Wo Hui Mandarin',
    sso_third_login_mock: 'ไปยัง HSK Mock',
    sso_for_china: 'บริการเว็บไซต์จีน (.cn)',
    sso_for_international: 'บริการเว็บไซต์สากล (.com)',
    other_gender: 'ไม่ระบุ/อื่นๆ',
    hsk_enter_listening: 'การฟัง',
    intro_msg_first: 'แบบทดสอบแบ่งออกเป็น{num} ส่วน  จำเป็นต้องทำตามลำดับ',
    intro_msg_second: 'กรุณาทำแบบทดสอบแต่ละส่วนให้เสร็จสิ้นภายในเวลาที่กำหนด',
    intro_msg_third: 'หากคุณทำแบบทดสอบในส่วนนี้เสร็จแล้วแต่ยังไม่หมดเวลา คุณสามารถคลิกดูข้อสอบในส่วนถัดไปได้ แต่ไม่สามารถย้อนกลับไปทำในส่วนก่อนหน้าได้',
    dialogue_listening: 'ส่วนแรกคือแบบทดสอบการฟัง โปรดคลิกปุ่มเพื่อเล่นเสียงทดสอบด้านล่าง พร้อมปรับแก้ไขอุปกรณ์ของคุณตามต้องการ',
    dialogue_listening_hskk: 'โปรดคลิกปุ่มเพื่อเล่นเสียงทดสอบด้านล่าง พร้อมปรับแก้ไขอุปกรณ์ของคุณตามต้องการ',
    dialogue_intro_msg_first: 'เมื่อเปิดไฟล์เสียง ขณะที่ดนตรีกำลังบรรเลงและมีการแนะนำข้อสอบอยู่นั้น คุณสามารถกดดูข้อสอบในส่วนการฟังล่วงหน้าได้',
    dialogue_intro_msg_first_hskk: 'เมื่อเปิดไฟล์เสียง ขณะที่ดนตรีกำลังบรรเลงและมีการแนะนำข้อสอบอยู่นั้น',
    dialogue_intro_msg_second: 'เพื่อจำลองการสอบให้เสมือนจริง ในส่วนการสอบฟัง คุณจะไม่สามารถหยุดเล่นเสียงชั่วคราว เล่นซ้ำ หรือกรอเสียงไปข้างหน้าได้',
    dialogue_intro_msg_second_hskk: 'คุณจะไม่สามารถหยุดเล่นเสียงชั่วคราว เล่นซ้ำ หรือกรอเสียงไปข้างหน้าได้',
    dialogue_intro_msg_third: 'หลังจากการฟังสิ้นสุดลง คุณจะมีเวลา{count}นาที ในการตรวจทานคำตอบ',
    dialogue_intro_question: 'พบปัญหาใช่หรือไม่',
    dialogue_preload_intro_first: 'กำลังดาวน์โหลดไฟล์เสียงในส่วนการฟัง',
    dialogue_preload_intro_second: 'หลังจากดาวน์โหลดเสร็จ ไฟล์เสียงจะเล่นขึ้นโดยอัตโนมัติ และเริ่มทำการสอบ',
    dialogue_preload_intro_third: 'ขอให้โชคดี',
    dialogue_preload_title: 'กำลังดาวน์โหลดข้อมูลการสอบ',
    mock_paper_preview: 'ตัวอย่างแบบทดสอบ',
    dialogue_mock_paper_intro_title: 'คำแนะนำในการสอบ',
    dialogue_mock_paper_intro_sentence1: 'การสอบนี้ใช้เวลาประมาณ { minutes} นาที โปรดตรวจสอบให้แน่ใจว่าคุณมีเวลาและแบตเตอรี่เพียงพอในการทำข้อสอบให้เสร็จภายในคราวเดียว',
    dialogue_mock_paper_intro_sentence2: 'การสอบนี้เป็นแบบออนไลน์ทั้งหมด ดังนั้นโปรดตรวจสอบให้แน่ใจว่าคุณมีการเชื่อมต่ออินเทอร์เน็ตที่เสถียร',
    dialogue_mock_paper_intro_sentence3: 'หากคุณใช้คอมพิวเตอร์ โปรดใช้เว็บเบราว์เซอร์ Chrome หรือ Safari เวอร์ชันล่าสุด',
    dialogue_mock_paper_intro_sentence4: 'หากคุณใช้แท็บเล็ต โปรดใช้APPแทนเว็บเบราว์เซอร์',
    dialogue_mock_paper_intro_sentence5: 'ในระหว่างการสอบ โปรดอย่าเปิดหน้าต่างเบราว์เซอร์หรือแอปพลิเคชันอื่นๆ  เปลี่ยนภาษา  เสียบหรือถอดปลั๊กอุปกรณ์อื่นๆ (เช่น USB หูฟัง เป็นต้น)',
    diologue_mock_paper_quit: 'ออก',
    dialogue_mock_paper_intro_button: 'ข้าพเจ้าได้อ่านและเข้าใจแล้ว',
    vocab_type: 'ชนิดของคำ',
    deadline_passed: 'เกินเวลาที่กำหนด',
    mock_skip_introduction: 'ข้ามคำแนะนำ',
    Listening: 'การฟัง',
    Reading: 'การอ่าน',
    Writing: 'การเขียน',
    personal_info_display_name_as: 'เกียรติบัตรออกในนาม',
    code_pratice_text: 'ทำแบบทดสอบจำลอง <span style="font-weight: 600;color: #0C0C0C"> {level_name} </span> โดยใช้  <span style="font-weight: 600;color: #0C0C0C"> {paper_name} </span> ',
    code_input_text: 'ใส่รหัสแลกแบบทดสอบ',
    use_code_limit: 'แต่ละ Code สามารถใช้ได้เพียงครั้งเดียวเท่านั้น',
    code_select_text: 'หรือเลือกรหัสแลกรับแบบทดสอบ 1 รหัส',
    pay_discounts_desc1: 'ฝึกฝนผ่านการทำข้อสอบจริงในอดีต สามารถช่วยคุณได้',
    pay_discounts_desc2: 'รับคะแนนที่ดีที่สุดในการสอบ [{type}] [{level}] ของคุณ',
    pay_discounts_desc3: 'ซื้อ1แถม1',
    pay_discounts_desc4: 'หากคุณได้ลงทะเบียนสำหรับการสอบ [{type} {level}] อย่างเป็นทางการแล้ว คุณสามารถรับข้อเสนอพิเศษ "ซื้อ 1 แถม 1 " ในการซื้อแบบทดสอบ [{type} {level}]',
    pay_discounts_desc5: 'คุณต้องการซื้อแบบทดสอบจำนวนเท่าไร',
    level_HSKK_text1: 'การทดสอบการพูด HSK เป็นการทดสอบความสามารถในการพูดภาษาจีนของผู้สอบ แบ่งออกเป็น 3 ระดับ: ระดับต้น ระดับกลาง และระดับสูง',
    level_HSKK_text2: 'การสอบพูด HSK จะใช้รูปแบบการบันทึกเสียง',
    level_HSKK_text3: 'ผู้เข้าสอบ HSK 3 จำเป็นต้องสอบ HSKK ระดับต้น ผู้เข้าสอบ HSK 4 จำเป็นต้องสอบ HSKK ระดับกลาง  ผู้เข้าสอบ HSK 5 และ 6 จำเป็นต้องสอบ HSKK ระดับสูง',
    test_download_desc: 'กําลังเตรียมแบบทดสอบสําหรับระดับนี้ ในระหว่างนี้ โปรดดาวน์โหลด:',
    speaking: 'การพูด',
    Traduction: 'การแปล',
    my_homework_none_homework: 'ระดับนี้ยังไม่รองรับการส่งแบบทดสอบ โปรดติดตามความคืบหน้าต่อไป',
    my_class_none_test: 'การทดสอบจำลองออนไลน์ยังไม่พร้อมใช้งานสำหรับระดับนี้  โปรดติดตามความคืบหน้าต่อไป',
    sso_join_campus_text1: 'เข้าสู่ระบบหรือลงทะเบียนเข้าร่วมชุมชนการสอน การเรียน และการสอบ',
    sso_join_campus_text3: 'ครูที่เข้าร่วมชุมชนสามารถส่งแบบทดสอบให้คุณบน HSKMock.com หรือมอบหมายแบบฝึกหัดบน app.wohuimandarin.comได้',
    sso_join_campus_text4: 'ครูสามารถตรวจดูคำตอบขอบคุณได้ เพื่อที่จะให้ข้อเสนอแนะได้อย่างตรงจุด',
    mock_join_campus_text1: 'คุณยอมรับคำเชิญในการเข้าร่วมชุมชนการสอน การเรียน และการสอบภาษาจีนนี้หรือไม่',
    mock_join_campus_text2: 'หลังจากเข้าร่วมชุมชนแล้ว ครูสามารถส่งแบบทดสอบให้คุณบน HSKMock.com หรือมอบหมายแบบฝึกหัดบน app.wohuimandarin.comได้',
    hsk_audio_error: 'เครือข่ายอินเทอร์เน็ตปัจจุบันของคุณไม่เสถียร  ดาวน์โหลดไฟล์เสียงไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
    free_practice_title: 'แบบฝึกหัดฟรี',
    choose_free_practice: 'เลือกวิธีการฝึก',
    word_flashcards: 'บัตรคำศัพท์',
    word_practice: 'ฝึกคำศัพท์',
    analyse_text: 'วิเคราะห์เนื้อหา',
    flashcards_title: 'บัตรคำ',
    practice_exercises_title: 'แบบฝึกหัด',
    analyse_title: 'วิเคราะห์',
    practice_result_title: 'ผลการฝึก',
    generate_flashcards: 'สร้างกลุ่มบัตรคำศัพท์',
    generate_practice: 'สร้างกลุ่มแบบฝึกหัด',
    random_select: 'เลือกแบบสุ่ม',
    manual_select: 'เลือกเอง',
    max_words: 'มากที่สุด {number} คำ',
    already_choose: 'เลือกแล้ว{total}คำ',
    free_practice_unchoose_question: 'โปรดเลือกประเภทของคำถาม',
    free_practice_unchoose_practice: 'โปรดเลือกรูปแบบของแบบฝึกหัด',
    none_mark_words_hint: 'คำศัพท์ที่ยังไม่บุ๊กมาร์ก',
    excceed_max_count: 'สามารถเลือกได้มากที่สุด{total}คำ คุณเลือกถึงจำนวนที่กำหนดแล้ว',
    free_practice_sound: 'เสียง',
    free_practice_question: 'คำถาม',
    free_practice_choose_exercise: 'เลือกประเภทของแบบฝึกหัด',
    free_practice_exercise_select: 'เลือก 1 รายการ',
    free_practice_exercise_Pairs: 'จับคู่',
    free_practice_exercise_TF: 'เลือกถูก(T)หรือผิด(F)',
    launch: 'เริ่ม',
    free_practice_check_text: 'แน่ใจว่าทำถูกต้องแล้วใช่ไหม',
    free_practice_timer_pause: 'หยุดเวลาชั่วคราว',
    free_practice_timer_pause_desc: 'หากตรวจไม่พบกิจกรรมใดๆ เวลาจะหยุดเดินชั่วคราว',
    free_practice_seconds: '{number}วินาที',
    resume: 'เริ่มใหม่อีกครั้ง',
    flashcard_completed: 'ภารกิจบัตรคำเสร็จสิ้นเเล้ว',
    practice_completed: 'ทำแบบฝึกหัดเสร็จสิ้นแล้ว',
    practice_spent_minutes: 'ใช้เวลาไปทั้งหมด{duration}นาที',
    practice_result_summary: 'สรุปผล',
    practice_result_progress_txt: 'คุณได้',
    practice_wrong: 'ผิด',
    practice_skip: 'ข้าม',
    practice_done: 'เสร็จสิ้น',
    analyse_desc_1: 'วิเคราะห์คำศัพท์ที่เลือกในบทความ',
    analyse_desc_2: 'วางหรือใส่ข้อความภาษาจีน (ได้มากที่สุดไม่เกิน{maxCount}ตัวอักษร)',
    analyse_input_placeholder: 'ใส่ข้อความภาษาจีน',
    free_practice_need_word: 'เลือกคำศัพท์จากตารางหรือเลือกแบบอัตโนมัติ',
    free_practice_exercise_select_title: 'เลือกคำตอบที่ถูกต้อง',
    free_practice_exercise_pairs_title: 'คลิกเพื่อเชื่อมต่อการจับคู่',
    free_practice_exercise_meaning_title: 'ควรแปลว่า',
    free_practice_exercise_sound_title: 'ควรอ่านว่า',
    free_practice_exercise_characters_title: 'ควรเขียนว่า',
    free_practice_show_correct_answers: 'แสดงคำตอบที่ถูกต้อง',
    free_practice_check: 'ตรวจสอบ',
    free_practice_show_my_answers: 'แสดงคำตอบของฉัน',
    free_practice_correct:'ถูก',
    free_practice_characters: 'คำศัพท์',
       hsk_introduce_objective_questions: 'คำถามเชิงภววิสัย',
  hsk_introduce_subjective_questions: 'คำถามเชิงอัตวิสัย',
  hsk_input_type_here: 'โปรดพิมพ์ที่นี่',
  hsk_translation_part_title: 'การแปลส่วนที่{count}',
  hsk_speaking_part_title: 'การพูดส่วนที่{count}',
  subjective_reading_placeholder: 'จงตอบคำถามจากบทความข้างต้น',
  hsk_write_by_artical: 'จงเขียนบทความตามข้อมูลข้างต้น',
  hsk_translation_by_artical: 'จงแปลข้อมูลจากข้างต้น',
  hsk_trasnlation_choose_language: 'ลำดับถัดไปเป็นส่วนการแปล กรุณาเลือกภาษา',
  choose_speaker: 'เลือกลำโพง',
  choose_microphone: 'เลือกไมโครโฟน',
  hsk_is_recording: 'กำลังบันทึกเสียง',
  dialogue_speaking: 'ส่วนสุดท้ายคือส่วนการพูด โปรดตรวจสอบให้แน่ใจว่าลำโพงและไมโครโฟนของคุณสามารถใช้งานได้ตามปกติ',
  start_recording: 'คลิกเพื่อเริ่มบันทึกเสียง',
  hsk_write_count: 'จำนวนตัวอักษร',
  error_access_media: 'เกิดข้อผิดพลาดขณะเข้าถึงอุปกรณ์สื่อ',
  setSinkId_not_supported: 'เบราว์เซอร์ของคุณไม่สนับสนุน{setSinkId}',
  error_switch_device: 'เกิดข้อผิดพลาดขณะสลับอุปกรณ์',
  translation_section: 'ส่วนการแปล',
  speaking_section: 'ส่วนการพูด',
  failed_upload_record: 'การอัปโหลดเสียงที่บันทึกล้มเหลว โปรดคลิกเพื่ออัปโหลดอีกครั้ง',
  hsk_enter_next_segment_write_high: 'ต้องการส่งคำตอบในส่วนการเขียนใช่หรือไม่ หลังจากกดส่งแล้ว การสอบเขียนจะสิ้นสุดลง และไม่สามารถกลับไปแก้ไขได้',
  hsk_enter_next_segment_translate_tip: 'คุณมี{count}ข้อที่ยังไม่ตอบในส่วนการแปล',
  hsk_enter_next_segment_translate: 'ต้องการส่งคำตอบในส่วนการแปลใช่หรือไม่ หลังจากกดส่งแล้ว การสอบแปลจะสิ้นสุดลง และไม่สามารถกลับไปแก้ไขได้',
  hsk_enter_next_segment_speaking_tip: 'คุณมี{count}ข้อที่ยังไม่ตอบในส่วนการพูด',
  Speaking: 'การพูด',
  Translating: 'การแปล',
}
